import React from 'react'
import { CheckFlags } from 'util/feature-flags'


export default (node:any, params:any, options:any) => {

  const flags= node.attribs['data-id-flag'].split(',') as String[]

  let showNode = true

  for (let flag of flags) {
    if (CheckFlags(flag) === false) showNode = false
  }
  
  return showNode ? node : <React.Fragment />
}